import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

function getInitialData() {
  const dataElement = document.getElementById("app-initial-data");
  if (dataElement && dataElement.textContent) {
    try {
      return JSON.parse(dataElement.textContent);
    } catch (e) {
      console.error("Failed to parse initial data", e);
    }
  }
  if (process.env.NODE_ENV === "development") {
    return {
      q34po5ufn9384ycnraosh: true,
      email: "john.doe@example.com",
      displayName: "John Doe",
    };
  }
  return {};
}
const initialData = getInitialData();

const root = ReactDOM.createRoot(
  document.getElementById("MatrixWordBuilder") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App
      isLoggedIn={initialData.q34po5ufn9384ycnraosh || false}
      email={initialData.email}
      displayName={initialData.displayName}
    />
  </React.StrictMode>
);
